import type { DemoSet } from '../../types'
import { invoiceAuditInsight } from './insight'
import { invoiceAudit } from './scripts/invoiceAudit'
import { recoveryAtScale } from './scripts/recoveryAtScale'

/**
 * Invoice Audit Agent — the finance chair of the Cascade 3PL world (see
 * `sets/cascade-3pl`). Persona: Sofia Reyes, Controller. Zero-integration
 * freemium wedge: upload a carrier invoice + the contracted rate card, get a
 * hard-dollar recovery number and carrier-ready dispute drafts in the same
 * session. Two acts — one-invoice wedge (`invoice-audit`) → 90-day sweep +
 * always-on agents (`recovery-at-scale`). See `docs/demos/invoice-audit.md`.
 *
 * SHARED WORLD with `cascade-3pl`: same company, revenue band, carriers, and
 * customer names. Numbers live in `./data.ts` and agree with the ops set.
 *
 * Scripts, insights, dashboard, and mock agents are added act-by-act by the
 * building skill; scaffolded here with the set registered and the chat-hero
 * insight in place.
 */
export const invoiceAuditSet: DemoSet = {
  id: 'invoice-audit',
  name: 'Cascade 3PL — Finance',
  description:
    'Invoice Audit Agent — finance chair of the Cascade 3PL world. Zero-integration wedge: upload a carrier invoice + rate card, get a hard-dollar recovery number and carrier-ready dispute drafts in the same session. Two acts: one-invoice audit → 90-day recovery at scale + always-on auditors.',
  scripts: [invoiceAudit, recoveryAtScale],
  insight: invoiceAuditInsight,
  userPersona: {
    firstName: 'Sofia',
    lastName: 'Reyes',
  },
}
